import { useEffect } from 'react';
import { useSiteData } from '@/context/SiteDataContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Resolve a stored favicon URL — may be a relative /api/files/... path or an absolute URL.
const resolveUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return `${BACKEND_URL}${url}`;
};

// Dynamically updates <link rel="icon"> tags whenever settings.favicon changes.
// Falls back to the static /favicon.ico shipped in /public.
export default function FaviconApplier() {
  const { settings } = useSiteData();
  useEffect(() => {
    const custom = resolveUrl(settings?.favicon);
    if (!custom) return;

    // Remove any previously injected dynamic favicon links
    document.querySelectorAll('link[data-dynamic-favicon]').forEach(el => el.remove());

    // Also remove any existing static rel="icon" tags so ours wins in every browser
    document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]').forEach(el => el.remove());

    const rels = [
      { rel: 'icon', type: 'image/png' },
      { rel: 'shortcut icon', type: 'image/png' },
      { rel: 'apple-touch-icon', sizes: '180x180' },
    ];
    rels.forEach(({ rel, type, sizes }) => {
      const link = document.createElement('link');
      link.setAttribute('data-dynamic-favicon', '1');
      link.rel = rel;
      if (type) link.type = type;
      if (sizes) link.setAttribute('sizes', sizes);
      // Cache-buster so browsers refresh the tab icon after an upload
      link.href = `${custom}${custom.includes('?') ? '&' : '?'}v=${Date.now()}`;
      document.head.appendChild(link);
    });
  }, [settings?.favicon]);
  return null;
}
